// Web Push helpers — service worker registration + subscription.
import { api } from "./api";

const SW_URL = "/sw.js";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register(SW_URL, { scope: "/" });
    await navigator.serviceWorker.ready;
    return reg;
  } catch (e) {
    console.warn("SW registration failed", e);
    return null;
  }
}

export async function getExistingSubscription() {
  if (!("serviceWorker" in navigator)) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Push not supported on this browser.");

  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error(perm);

  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerSW());
  if (!reg) throw new Error("Service worker registration failed.");

  // Re-use existing subscription if present
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { public_key } = await api.getVapidPublicKey();
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key),
    });
  }

  const tz_offset_minutes = -new Date().getTimezoneOffset(); // east of UTC positive
  await api.pushSubscribe({ subscription: sub.toJSON(), tz_offset_minutes });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getExistingSubscription();
  if (!sub) {
    await api.pushUnsubscribe({ subscription: {} });
    return;
  }
  try {
    await api.pushUnsubscribe({ subscription: sub.toJSON() });
  } catch {}
  await sub.unsubscribe();
}

export async function sendTestPush() {
  return api.pushTest();
}
